﻿import { formPreventMultipleSubmit } from '../../es6/helpers/Forms.js';

// === Polyfill for IE 11 ===
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

if (!Array.prototype.includes) {
    Array.prototype.includes = function () {
        'use strict';
        return Array.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

// === END Polyfill for IE 11 ===

if (!Array.prototype.find) {
    Array.prototype.find = function (predicate) {
        'use strict';
        if (this == null) {
            throw new TypeError('Array.prototype.find called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return value;
            }
        }
        return undefined;
    };
}

if (!Date.prototype.toShortDateString) {
    Date.prototype.toShortDateString = function () {
        return (
            this.getFullYear() +
            '-' +
            ('0' + (this.getMonth() + 1)).slice(-2) +
            '-' +
            ('0' + this.getDate()).slice(-2)
        );
    };
}

const GroCommon = (function () {
    var isInternal = function () {
        var isInternal = Number.parseInt($('#IsInternal').val()) == 1;

        return isInternal;
    };

    var dateFromISO = function (s) {
        s = s.split(/\D/);
        return new Date(
            Date.UTC(s[0], --s[1] || '', s[2] || '', s[3] || '', s[4] || '', s[5] || '', s[6] || '')
        );
    };

    var parseInt32 = function (s) {
        var value = parseInt(s);
        if (isNaN(value)) value = 0;

        return value;
    };

    var parseBool = function (s) {
        if (s === 'true' || s === 'True' || s === '1') {
            return true;
        }

        return false;
    };

    var blockUI = function () {
        //Block UI
    };

    var unblockUI = function () {
        //Unblock UI
    };
    var handleExternalLink = function () {
        var $a = $('a');
        $a.each(function () {
            var href = $(this).attr('href');
            var target = $(this).attr('target');

            if (!!target) {
                return;
            }

            if ($(this).closest('.agri-chart__content').length) {
                return;
            }

            var isExternalLink =
                href != undefined &&
                href.trim().indexOf('/') !== 0 &&
                href.trim().indexOf('./') !== 0 &&
                href.trim() !== '#' &&
                href.trim() !== '?' &&
                href.substring(0, 1) !== '#' &&
                href.trim().indexOf('javascript:') < 0 &&
                href.trim().indexOf('mailto:') < 0 &&
                href.trim().indexOf('tel:') < 0 &&
                href.trim().indexOf('lm2') < 0;
            if (isExternalLink) {
                $(this).attr('target', '_blank');
            }
        });
    };

    var getIdxOfElement = function ($element, $array) {
        return $array.index($element);
    };

    var disableOrEnableElement = function (elementSelector, $currentInput, $recursive) {
        var agreementElements = $(elementSelector);
        var $currentElement = $currentInput.closest(elementSelector);
        var $isEmpty = $currentInput.html().trim() + $currentInput.val().trim() === '';
        if (agreementElements.length > 0) {
            var idx = getIdxOfElement($currentElement, $(agreementElements));
            if (idx >= 0 && idx < agreementElements.length - 1) {
                // enable the element right after the current element.
                var $nextElement = $(agreementElements[idx + 1]);
                if (!$isEmpty && $nextElement.hasClass('disabled')) {
                    $nextElement.removeClass('disabled');
                    disableOrEnableElement(elementSelector, $nextElement.find('input'));
                } else if (($isEmpty || $recursive) && !$nextElement.hasClass('disabled')) {
                    $nextElement.addClass('disabled');
                    disableOrEnableElement(elementSelector, $nextElement.find('input'), true);
                }
            }
        }
    };

    var modalInfoClass = {
        warning: 'warning',
        error: 'warning',
        info: '-info-circle',
        success: 'success',
    };

    var getModalIconClass = function (popupType) {
        if (!popupType) {
            return '';
        }
        var cssClass = modalInfoClass[popupType];
        if (!cssClass) {
            cssClass = '';
        }
        return cssClass;
    };

    var joinUrlParts = function () {
        var urlParts = [];

        for (var i = 0; i < arguments.length; i++) {
            var urlPart = arguments[i];

            if (urlPart.substr(0, 1) === '/') {
                urlPart = urlPart.slice(1); // remove first char
            }
            if (urlPart.substr(-1) === '/') {
                urlPart = urlPart.slice(0, -1); // remove last char
            }

            urlParts.push(urlPart);
        }

        return urlParts.join('/');
    };

    var MarketSite = {
        Sweden: 'se',
        Finland: 'fi',
    };

    var currentMarketSite = function () {
        var host = window.location.host;

        if (host.slice(-2) === 'fi') {
            return MarketSite.Finland;
        } else {
            return MarketSite.Sweden;
        }
    };

    /**
     * @returns True if current site is Finland, otherwise false
     */
    var currentMarketSiteIsFinland = function () {
        return this.currentMarketSite() === this.MarketSite.Finland;
    };

    return {
        isInternal: isInternal,
        blockUI: blockUI,
        unblockUI: unblockUI,
        handleExternalLink: handleExternalLink,
        dateFromISO: dateFromISO,
        parseInt: parseInt32,
        parseBool: parseBool,
        getModalIconClass: getModalIconClass,
        modalInfoClass: modalInfoClass,
        disableOrEnableElement: disableOrEnableElement,
        joinUrlParts: joinUrlParts,
        MarketSite: MarketSite,
        currentMarketSite: currentMarketSite,
        currentMarketSiteIsFinland: currentMarketSiteIsFinland,
    };
})();

const autoFitImages = (query) => {
    var images = $(query);

    images.each(function () {
        $(this).imgLoad(function () {
            var $this = $(this);
            var size = {
                width: $(this).width(),
                height: $(this).height(),
            };
            if (size.height < size.width) {
                if (size.width / size.height > $this.parent().width() / $this.parent().height()) {
                    $(this).removeClass('horizontal-img').addClass('vertical-img');
                } else {
                    $(this).removeClass('vertical-img').addClass('horizontal-img');
                }
            } else {
                if (size.height / size.width > $this.parent().height() / $this.parent().width()) {
                    $(this).removeClass('vertical-img').addClass('horizontal-img');
                } else {
                    $(this).removeClass('horizontal-img').addClass('vertical-img');
                }
            }
        });
    });
};

var ImagePlaceHolder = function () {
    var elements = $('img[data-img-source]');
    elements.each(function () {
        var element = this;
        $(element).attr('src', $(element).data('imgSource'));
        $(element).on('error', function (event) {
            $(event.target).on('error', null);
            if ($(event.target).data('placeholder')) {
                $(event.target).attr('src', $(event.target).data('placeholder'));
            }
        });
    });
};

const UploadImageModule = (options) => {
    var settings = {
        fileSelector: '',
        previewImgSelector: '',
        uploadBtnSelector: '',
        linkSelector: '',
        handleUrl: '',
        cancelUploadBtnSelector: '',
        deleteLinkSelector: '',
        handleDeleteUrl: '',
        errorMessage: '',
        prevImageData: '',
        isNeedToUpdateHeader: false,

        messages: {
            confirmationDialogSelector: '#dialog-confirmation',
            delConfirmationMess: 'Är du säker på att du vill ta bort bilden?',
            yesDelBtnText: 'Ja, ta bort',
            noDelBtnText: 'Nej, spara den',

            uploadingErrorMessage:
                'Något gick fel när du försökte ladda upp bilden. Vänligen försök igen.',
            uploadingErrorTitle: 'Bilden kunde inte laddas upp',

            informationDialogSelector: '#informationDialog',
        },
        //addition for dialogs
        //confirmationDialogSelector: "#dialog-confirmation",
        //delConfirmationMess: "Är du säker på att du vill ta bort bilden?",
        //yesDelBtnText: "Ja, ta bort",
        //noDelBtnText: "Nej, spara den"
    };
    var _prevImageData;
    var _data = []; //add params to request following format [{"key": "id", "value": 1},{"key": "name", "value": "abc"}]
    var dialogType = GroCommon.modalInfoClass;

    $.extend(settings, options);

    var buildParamsForRequest = function () {
        var data = new FormData();
        if (_data && _data.length > 0) {
            for (var i = 0; i < _data.length; i++) {
                var param = _data[i];
                if (param.key && param.value) {
                    data.append(param.key, param.value);
                }
            }
        }
        return data;
    };

    var attachFileOnChangeEvent = function () {
        $(settings.fileSelector).change(function () {
            var file = this.files[0];
            var imagefile = file.type;
            var match = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!(imagefile === match[0] || imagefile === match[1] || imagefile === match[2])) {
                $(settings.previewImgSelector).attr('src', _prevImageData);
                return false;
            } else {
                var reader = new FileReader();
                reader.onload = function (event) {
                    $(settings.previewImgSelector).attr('src', event.target.result);
                    //show Cancel/Upload buttons
                    $(settings.uploadBtnSelector).parent().show();
                };
                reader.readAsDataURL(this.files[0]);
            }
        });
    };

    var attachOpenFileDialog = function () {
        $(settings.linkSelector).on('click', function (e) {
            $('.popup-sub, .list-action-item').hide();
            e.preventDefault();
            $(settings.fileSelector).trigger('click');
        });
    };

    var attachUploadFileClickEvent = function () {
        $(settings.uploadBtnSelector).on('click', function () {
            var data = buildParamsForRequest();
            var files = $(settings.fileSelector).get(0).files;

            // Add the uploaded image content to the form data collection
            if (files.length > 0) {
                var fileSize = files[0].size;
                if (fileSize > 10485760) {
                    showInformationDialog(
                        '',
                        'Filen är för stor. Maximal filstorlek 10MB.',
                        dialogType.error
                    );
                    return;
                }
                data.append('UploadedImage', files[0]);
            }
            $(settings.previewImgSelector).prev().show();
            $(settings.uploadBtnSelector).parent().hide();
            $.ajax({
                url: settings.handleUrl,
                type: 'POST',
                data: data,
                contentType: false, // The content type used when sending data to the server.
                cache: false,
                processData: false, // To send DOMDocument or non processed data file it is set to false
                success: function (result) {
                    $(settings.previewImgSelector).prev().hide();

                    if (result.success) {
                        $(settings.uploadBtnSelector).parent().hide();
                        $(settings.deleteLinkSelector).show();

                        _prevImageData = $(settings.previewImgSelector).attr('src');
                        if (settings.isNeedToUpdateHeader) {
                            $('.lm__user-avatar-wrapper .header_user_avatar').attr(
                                'src',
                                _prevImageData
                            );
                        }

                        autoFitImages('.machine-item__thumbnail-wrapper img');
                    } else {
                        $(settings.previewImgSelector).attr('src', _prevImageData);
                        //var message = settings.errorMessage!=="" ? settings.errorMessage : "Det uppstod ett fel när bilden skulle laddas upp. Var god försök igen!";
                        showInformationDialog(
                            settings.messages.uploadingErrorTitle,
                            settings.messages.uploadingErrorMessage,
                            dialogType.error
                        );
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $(settings.previewImgSelector).prev().hide();
                    $(settings.previewImgSelector).attr('src', _prevImageData);
                    var message =
                        'Det uppstod ett fel när bilden skulle laddas upp: ' +
                        errorThrown.toString();
                    showInformationDialog(settings.uploadingErrorTitle, message, dialogType.error);
                },
            });
        });
    };

    var attactCancelUploadEvent = function () {
        $(settings.cancelUploadBtnSelector).on('click', function () {
            //$(_fileSelector).val('');
            $(settings.fileSelector).val('');
            $(settings.uploadBtnSelector).parent().hide();
            $(settings.previewImgSelector).attr('src', _prevImageData);
        });
    };
    var deleteImage = function () {
        $(settings.previewImgSelector).prev().show();
        $('.popup-sub, .list-action-item').hide();

        var data = buildParamsForRequest();

        $.ajax({
            url: settings.handleDeleteUrl,
            type: 'POST',
            data: data,
            contentType: false, // The content type used when sending data to the server.
            cache: false,
            processData: false, // To send DOMDocument or non processed data file it is set to false
            success: function (result) {
                $(settings.previewImgSelector).prev().hide();
                if (result.success) {
                    _prevImageData = result.imageUrl;

                    $(settings.deleteLinkSelector).hide();
                    $(settings.previewImgSelector).attr('src', _prevImageData);

                    if (settings.isNeedToUpdateHeader) {
                        //only using for update user avatar on header
                        $('.lm__user-avatar-wrapper .header_user_avatar').attr(
                            'src',
                            _prevImageData
                        );
                    }
                } else {
                    $(settings.previewImgSelector).attr('src', _prevImageData);
                    showInformationDialog(
                        '',
                        'Det uppstod ett fel när bilden skulle tas bort. Var god försök igen!',
                        dialogType.error
                    );
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $(settings.previewImgSelector).prev().hide();
                $(settings.previewImgSelector).attr('src', _prevImageData);
                var message =
                    'Det uppstod ett fel när bilden skulle tas bort: ' + errorThrown.toString();
                showInformationDialog(message, '', dialogType.error);
            },
        });
    };

    var attachDeleteFileClickEvent = function () {
        $(settings.deleteLinkSelector).on('click', function () {
            showDelConfirmationDialog(deleteImage);
        });
    };

    function showDelConfirmationDialog(callback) {
        var $dialog = $(settings.messages.confirmationDialogSelector);
        if ($dialog.length === 0) {
            return;
        }
        $('.modal-header-title', $dialog).html(settings.delConfirmationMess);
        var $yesBtn = $('.success-confirm-inform.yes', $dialog);
        var $noBtn = $('.success-confirm-inform.no', $dialog);
        $noBtn.html(settings.noDelBtnText);
        $yesBtn.html(settings.yesDelBtnText);

        $yesBtn.click(function () {
            callback();
        });

        $dialog.fadeIn();
    }
    var initDataForRequest = function (data) {
        _data = data;
    };

    var initUploadFile = function (options) {
        if (!options) {
            $.extend(settings, options);
        }
        _prevImageData = $(settings.previewImgSelector).attr('src');

        attachOpenFileDialog();
        attachFileOnChangeEvent();
        attachUploadFileClickEvent();
        attactCancelUploadEvent();
    };

    var initDeleteFile = function (options) {
        if (!options) {
            $.extend(settings, options);
        }

        attachDeleteFileClickEvent();
    };

    function showInformationDialog(title, message, dialogType) {
        var $informationDialog = $(settings.messages.informationDialogSelector);
        var $iconElement = $informationDialog.find('span.popup-type');
        if (dialogType) {
            $iconElement.removeClass('hidden');
            $iconElement.addClass(GroCommon.getModalIconClass(dialogType));
        } else {
            $iconElement.addClass('hidden');
        }

        $informationDialog.find('#dialogTitle').html(title);
        $informationDialog.find('#dialogContent').html(message);
        if ($informationDialog.hasClass('hidden')) {
            $informationDialog.removeClass('hidden');
        } else {
            $informationDialog.fadeIn();
        }
    }

    return {
        initDataForRequest: initDataForRequest,
        initUploadFile: initUploadFile,
        initDeleteFile: initDeleteFile,
    };
};

$(function () {
    ImagePlaceHolder();
});

$(function () {
    $('input[type=button].submit').click(function () {
        $(this).attr('disabled', 'disabled');
        var form = $(this).closest('form');
        if (form) {
            $(form).submit();
        }
    });

    /**
     * @description Handle form submit button
     */
    $('form').keyup(function (event) {
        if (event.which === 13) {
            // key enter
            var form = $(event.target).closest('form');
            if (form) {
                var submitBtn = getSubmitBtn(form);

                if (submitBtn !== undefined) {
                    $(submitBtn).click();
                }
            }
        }
    });

    /**
     * @description Get submit button from form
     */
    function getSubmitBtn(form) {
        var btnSubmit = $('button.submit.trigger-on-enter', $(form));
        if (btnSubmit.length > 0) {
            return btnSubmit;
        }

        var btnTypeSubmit = $('button[type=submit].trigger-on-enter', $(form));
        if (btnTypeSubmit.length > 0) {
            return btnTypeSubmit;
        }

        var inputSubmit = $('input[type=submit].trigger-on-enter', $(form));
        if (inputSubmit.length > 0) {
            return inputSubmit;
        }
        return undefined;
    }

    /**
     * @description Handle EpiForm submit to avoid multiple submissions
     * @helper {formHandleOnSubmit} from es6/helpers/Forms.js
     */
    formPreventMultipleSubmit({
        form: '.EPiServerForms',
        container: '.articlePageEpiForm',
        submitButton: '.FormSubmitButton',
    });

    $('.lm__modal__wrapper .mask').on('click', function () {
        $(this).closest('.lm__modal__wrapper').addClass('hidden');
    });
});

$(function () {
    $('.lm__form-progress').each(function () {
        var step = $(this).find('li');
        var activeStep = $(this).find('li.active');
        var activeLine = $(this).find('.lm__form-progress__line');
        var endPoint = activeStep.offset().left - $(this).offset().left + step.width() / 2;
        activeLine.css({ width: endPoint });
    });
});

/**
 * @description Add scripts to DOM
 * @param {Array} scriptUrl - Array of script urls
 */
const addScripts = (scriptUrl, scriptType) => {
    for (let int = 0; int < scriptUrl.length; int++) {
        const script = document.createElement('script');
        let scriptId = `reactScripts_organization_${int}_${scriptType}`;

        script.type = 'module';
        script.src = scriptUrl[int];
        script.id = scriptId;

        document.body.appendChild(script);
    }
};

export { GroCommon, UploadImageModule, ImagePlaceHolder, autoFitImages, addScripts };
